import React, { useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { allReservationStatus, translateStatus } from '@crm/utils';

/**
 * Interface pour les props du composant ReservationStatusSelect
 */
interface ReservationStatusSelectProps {
  reservation: Partial<CRM.ReservationDocument>;
  activity: CRM.PublicActivity | undefined;
  onChange: (value: CRM.ReservationStatus) => any;
}

/**
 * Composant de sélection du statut de réservation
 * 
 * Ce composant :
 * - Affiche un sélecteur avec tous les statuts de réservation disponibles
 * - Initialise automatiquement le statut à "booked" si non défini
 * - Désactive certains statuts selon le type d'activité et le paiement
 * - Traduit les statuts pour l'affichage utilisateur
 * 
 * Logique métier :
 * - Activités supervisées : désactive "cancelled" et "gift-voucher"
 * - Réservations sans paiement : exclut le statut "cancelled"
 * - Initialisation automatique du statut par défaut
 * - Utilise les utilitaires de traduction des statuts
 * 
 * @param reservation Réservation partielle pour récupérer le statut actuel
 * @param activity Activité publique pour déterminer les restrictions
 * @param onChange Fonction de callback pour la modification du statut
 * @returns Composant React de sélection de statut
 */
export function ReservationStatusSelect({
  onChange,
  reservation,
  activity
}: ReservationStatusSelectProps) {
  useEffect(() => {
    if (!reservation.status) {
      onChange('booked');
    }
  }, [onChange, reservation]);

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="Status-select-label">Statut</InputLabel>
      <Select
        labelId="Status-select-label"
        value={reservation.status || ''}
        label="Statut"
        disabled={
          activity?.kind === 'supervised' && (
          reservation.status === 'cancelled' || reservation.status === 'gift-voucher'
          ) 
        }
        onChange={evt => onChange(evt.target.value as CRM.ReservationStatus)}
      >
        {allReservationStatus.filter(r => reservation.payment?.amountInEuro === 0/*Means no refund needed*/ ? r !== "cancelled" : r).map(status => (
          <MenuItem key={status} value={status}>
            {translateStatus(status)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
